import React, { useEffect,useMemo,useState} from 'react';
import { Box } from '@mui/material';

import {ClinicResponseModal,CreateMessageModal,MessageTimelineModal} from './components/PTMessageModals';

import PTMessageTable from './components/PTMessageTable';
import PageHeaderTabs from '../Common/components/PageHeaderTabs';

import {patientPageContentSx, patientPageRootSx} from '../Common/components/Styles/PatientPageStyles';

import { ptMessageRows } from './data';

const PTMessagesPage = () => {
  const [search, setSearch] = useState('');
  const [activeTab, setActiveTab] = useState('ALL');

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [selectedRow, setSelectedRow] = useState(null);

  const [openCreateMessage, setOpenCreateMessage] =
    useState(false);

  const [openClinicResponse, setOpenClinicResponse] =
    useState(false);

  const [openTimeline, setOpenTimeline] =
    useState(false);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const filteredRows = useMemo(() => {
    const searchValue = search
      .trim()
      .toLowerCase();

    return ptMessageRows.filter(row => {
      const matchesSearch =
        !searchValue ||
        Object.values(row).some(value =>
          String(value)
            .toLowerCase()
            .includes(searchValue)
        );

      const matchesStatus =
        activeTab === 'ALL' ||
        row.status === activeTab;

      return matchesSearch && matchesStatus;
    });
  }, [
    search,
    activeTab
  ]);

  const visibleRows = useMemo(() => {
    const start = page * rowsPerPage;

    return filteredRows.slice(
      start,
      start + rowsPerPage
    );
  }, [
    filteredRows,
    page,
    rowsPerPage
  ]);

  const handleActionClick = row => {
    setSelectedRow(row);

    if (row.status === 'Awaiting Clinic') {
      setOpenClinicResponse(true);
      return;
    }

    setOpenTimeline(true);
  };

  return (
    <>
      <Box sx={patientPageRootSx}>
        <PageHeaderTabs
          type="title"
          title="PT Messages"
        />

        <Box sx={patientPageContentSx}>
          <PTMessageTable
            search={search}
            activeTab={activeTab}
            page={page}
            rowsPerPage={rowsPerPage}
            rows={visibleRows}
            totalCount={filteredRows.length}
            loading={loading}
            onSearchChange={value => {
              setSearch(value);
              setPage(0);
            }}
            onStatusChange={value => {
              setActiveTab(value);
              setPage(0);
            }}
            onCreate={() =>
              setOpenCreateMessage(true)
            }
            onPageChange={(event, newPage) =>
              setPage(newPage)
            }
            onRowsPerPageChange={event => {
              setRowsPerPage(
                Number(event.target.value)
              );

              setPage(0);
            }}
            onActionClick={handleActionClick}
          />
        </Box>
      </Box>

      <CreateMessageModal
        open={openCreateMessage}
        onClose={() =>
          setOpenCreateMessage(false)
        }
      />

      <ClinicResponseModal
        open={openClinicResponse}
        data={selectedRow}
        onClose={() =>
          setOpenClinicResponse(false)
        }
      />

      <MessageTimelineModal
        open={openTimeline}
        data={selectedRow}
        onClose={() =>
          setOpenTimeline(false)
        }
      />
    </>
  );
};

export default PTMessagesPage;